import { GetWithAccessToken, PostWithAccessToken, PostWithReponse } from "../../../helpers/http";

export const GetIntakeFormData = async (companyId, caseId, patientId) => {
    return await GetWithAccessToken(`${process.env.REACT_APP_DOCTOR_API_URL}IntakeForm/Get?CompanyId=${companyId}&CaseId=${caseId}&PatientId=${patientId}`);
};

export const saveIntakeForm = async (data) => {
     return (
    await PostWithAccessToken(
      `${process.env.REACT_APP_DOCTOR_API_URL}IntakeForm/Save`,
      data
    )
  ).json();
}


